import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {DropTarget} from "react-dnd";
/*** components ***/
import SourceLidDnD from "../OptionsArea/SourceLidDnD";
import SleeveDragSource from "./SleeveDragSource";
/*** helpers ***/
import {ItemTypes} from "./ItemsTypes";
import {pushLidToTarget} from "../../../../actions/pushLidToTarget";
import {pushAddSleeveToSide} from "../../../../actions/pushAddSleeveToSide";
import {deleteSleeveToSide} from "../../../../actions/deleteSleeveToSide";
import {SIZE_OF_CELL, sleeveSize} from "../../../../constants/constants";

class Plan extends Component {
  render() {
    const {height} = this.props.buildValues;
    const {sleeves, lids} = this.props.buildValuesSides[this.props.currentStep - 2];
    const numberOfCellsHeight = height / SIZE_OF_CELL;
    const areaDimension = this.props.currentStep <= 3 ? "length" : "width";
    /*** style for wrapper of plan area ***/
    const stylesWrapper = {
      display: "grid",
      width: "auto",
      gridTemplateRows: `minmax(${this.props.sizeOfCell}px,${this.props.sizeOfCell * numberOfCellsHeight}px) 18px`,
      gridTemplateColumns: this.props.isVerticalArrow ? "calc( (100vw - 375px)/(1920 - 375) * (30 - 14) + 14px) 24px 1fr" : "24px 1fr",
      gridTemplateAreas: this.props.isVerticalArrow
        ? `"plan-area-vertical-arrows left-size-arrow plan"
            "size-arrow size-arrow size-arrow"`
        : `"left-size-arrow plan"
            "size-arrow size-arrow"`
    };

    /*** style for drop field***/
    const styleForInnerPlan = {
      width: "100%",
      display: "grid",
      gridTemplateRows: `repeat(${numberOfCellsHeight}, auto)`,
      gridTemplateColumns: `repeat(${this.props.numberOfCellsWidth}, auto)`
    };

    const styleForPlan = {
      width:
        this.props.sizeOfCell && this.props.numberOfCellsWidth
          ? `${this.props.sizeOfCell * this.props.numberOfCellsWidth}px`
          : "calc(100% - 2 * ((100vw - 375px)/(1920 - 375) * (32 - 15) + 15px))",
    };

    const styleForArrowSize = {
      gridColumnStart: this.props.isVerticalArrow ? 3 : 2,
      gridColumnEnd: this.props.isVerticalArrow ? 4 : 3,
    };

    const styleForOverallArrowSize = {
      gridColumnStart: this.props.isVerticalArrow ? 3 : 2,
      gridColumnEnd: this.props.isVerticalArrow ? 4 : 3,
      gridRowStart: 3,
      marginTop: '1vh'
    };

    /*** generate cells ***/
    const styleVertical = {
      marginLeft: `${this.props.sizeOfCell}px`
    };
    const verticalLines = [];
    const dimension =
      this.props.currentStep <= 3 ?
        this.props.buildValues.length :
        this.props.buildValues.width;
    for (let i = 0; i < this.props.numberOfCellsWidth; i++) {
      if (!i && dimension % 20) {
        const rest = dimension % SIZE_OF_CELL,
          firstMargin = rest * (this.props.sizeOfCell * this.props.numberOfCellsWidth) / dimension;
        verticalLines.push(
          <div className="vertical" style={{marginLeft: `${firstMargin / 2}px`}} key={i}/>
        );
      } else {
        verticalLines.push(
          <div className="vertical" style={styleVertical} key={i}/>
        );
      }
    }

    const styleHorizontal = {
      marginTop: `${this.props.sizeOfCell - 2}px`
    };
    const horizontalLines = [];
    for (let i = 0; i < numberOfCellsHeight - 1; i++) {
      horizontalLines.push(
        <div className="horizontal" style={styleHorizontal} key={i}/>
      );
    }

    /*** generate sleeves ***/
    const sleevesToRender = sleeves.map((item, index) => {
      /*** get real size of sleeve ***/
      const size = sleeveSize[item.background];

      /*** generate style for sleeve icon ***/
      /***
       * calculate top, left margin  and height(=width) )on page
       * using formula (REAL_SIZE / CALCULATED_SIZE) = (REAL_SIZE_OF_CELL / CELL_SIZE_ON_PAGE)
       * ***/
      const styles = {
        position: "absolute",
        top: `${item.top * this.props.sizeOfCell / SIZE_OF_CELL}px`,
        left: `${item.left * this.props.sizeOfCell / SIZE_OF_CELL}px`,
        background: item.background,
        width: `${size * this.props.sizeOfCell / SIZE_OF_CELL}px`,
        height: `${size * this.props.sizeOfCell / SIZE_OF_CELL}px`
      };
      return (
        <SleeveDragSource
          deleteSleeve={this.props.deleteSleeveToSide}
          key={index}
          index={index}
          id={index}
          isSleeveOnPlan={true}
          styles={styles}
          currentStep={this.props.currentStep}
          background={item.background}
          withoutDragging={this.props.withoutDragging}
        />
      );
    });

    /*** generate lids ***/
    let lidsToRender = [];
    if (!(height % 5) && lids) {
      lidsToRender = lids.filter((item) => {
        return item.invisibleFlag === undefined || item.invisibleFlag === false;
      }).map((item, index) => {
        if (item.top < 0)
          item.top = 0;
        item.top = Math.round(item.top);
        const width = this.props.sizeOfCell / 20 * item.length;
        const imHeight = this.props.sizeOfCell / 20 * item.height;
        const top = Math.round(item.top * this.props.sizeOfCell / 20);
        const left = item.left * this.props.sizeOfCell / 20;
        const styles = {
          position: "absolute",
          width: `${width}px`,
          height: `${imHeight}px`,
          top: `${top}px`,
          left: `${left}px`,
          opacity: 0.9,
          display:
            height < item.top + item.height ? "none" : "block"
        };
        return (
          <SourceLidDnD
            key={index}
            value={item.sagex}
            style={styles}
            id={`id-${index}`}
            index={index}
            isPlan={true}
            currentStep={this.props.currentStep}
            withoutDragging={this.props.withoutDragging}
          />
        );
      });
    }

    /**
     * sort bottom margin and size of sleeves and lids to create size arrows
     * **/
    let lidsToSort = [];
    lids.filter((item) => {
      return item.top >= 0;
    }).forEach((item) => {
      lidsToSort.push({
        bottom: Math.round(height - item.top),
        left: item.left,
        widthOfArrow: item.left * this.props.sizeOfCell / SIZE_OF_CELL,
        heightOfArrow: (height - item.top) * this.props.sizeOfCell / SIZE_OF_CELL
      });
      lidsToSort.push({
        bottom: Math.round(height - (item.top + item.height)),
        left: (item.left + item.length),
        widthOfArrow: (item.left + item.length) * this.props.sizeOfCell / SIZE_OF_CELL,
        heightOfArrow: (height - item.top - item.height) * this.props.sizeOfCell / SIZE_OF_CELL
      });
    });

    let sleevesToSort = [...sleeves];

    sleevesToSort = sleevesToSort.map((item) => {
      return {
        left: item.left + sleeveSize[item.background] / 2,
        bottom: Math.round((height - (item.top + sleeveSize[item.background] / 2)) * 100) / 100,
        widthOfArrow: (item.left + sleeveSize[item.background] / 2) * this.props.sizeOfCell / SIZE_OF_CELL,
        heightOfArrow: (height - item.top - (sleeveSize[item.background] / 2)) * this.props.sizeOfCell / SIZE_OF_CELL
      }
    });

    sleevesToSort = [...sleevesToSort, ...lidsToSort];

    /**
     * render()'s return
     */
    return this.props.connectDropTarget(
      <div className="wrapper-plan-2-step-2" style={stylesWrapper}>
        <div
          className="left-size-arrow"
          style={{
            marginLeft: '-1.2em',
            gridColumnStart: 1
          }}
        >
          {this.createLeftOverallSizeArrow()}
        </div>
        <div
          className="left-size-arrow"
        >
          {this.createLeftSizeArrows(sleevesToSort)}
        </div>
        <div
          className="plan-step-2"
          style={styleForPlan}
        >
          {this.props.withoutResize ? null : (
            <div
              className="plan-dragbar"
              onMouseDown={this.props.startResizing}
            />
          )}
          <div
            className="inner-plan-step-2"
            data-area-name={this.props.areaName}
            data-area-dimension={areaDimension}
            style={styleForInnerPlan}
          >
            <div className="vertical-group">{verticalLines}</div>
            <div className="horizontal-group rotate180">{horizontalLines}</div>
            {sleevesToRender}
            {lidsToRender}
          </div>
        </div>
        <div className={`size-arrow`} style={styleForArrowSize}>
          {this.createBottomSizeArrows(sleevesToSort, areaDimension)}
        </div>
        <div className={`size-arrow`} style={styleForOverallArrowSize}>
          {this.createBottomOverallSizeArrow(areaDimension)}
        </div>
      </div>
    );
  }

  createLeftSizeArrows(sleevesToSort) { // todo consider renaming sleevesToSort to something appropriate
    /***
     * sort sleeves using heightOfArrow and then delete the elements with the same heightOfArrow
     */
    const leftSizeArrow = sleevesToSort.sort((a, b) => {
      return a.bottom > b.bottom ? 1 : -1;
    }).filter((item, pos, self) => {
      return !pos || item.bottom !== self[pos - 1].bottom;
    });

    /***
     * generate left arrows for sleeves
     */
    const leftArrows = leftSizeArrow.map((item, index, self) => {
      const height = !index ? item.heightOfArrow : (item.heightOfArrow - self[index - 1].heightOfArrow);
      if (index === self.length - 1) {
        const lastLeftArrowHeight = (this.props.buildValues.height * this.props.sizeOfCell / SIZE_OF_CELL) - item.heightOfArrow - 0;
        return (
          <React.Fragment key={index}>
            {
              Plan.createLeftSizeArrow(
                height,
                index,
                this.getArrowValue(!index ? item.bottom : (item.bottom - self[index - 1].bottom)))
            }
            {
              item.bottom !== this.props.buildValues.height
                ? Plan.createLeftSizeArrow(
                    lastLeftArrowHeight,
                    "blelbleldlf",
                    this.getArrowValue(this.props.buildValues.height - item.bottom))
                : null
            }
          </React.Fragment>
        )
      }
      return Plan.createLeftSizeArrow(
        height,
        index,
        this.getArrowValue(!index ? item.bottom : (item.bottom - self[index - 1].bottom)))
    });
    return leftArrows;
  }

  createLeftOverallSizeArrow() {
    const height = this.props.buildValues.height
    const arrowValue = this.getArrowValue(height)
    const heightOnScreen = height * this.props.sizeOfCell / SIZE_OF_CELL

    return Plan.createLeftSizeArrow(heightOnScreen, height, arrowValue)
  }

  static createLeftSizeArrow(height, key, arrowValue) {
    return (
      <div className={`left-size-arrow-item`} key={key}>
        <div className="left-size-arrow-item-border"/>
        <div className="left-size-arrow-item-line" style={{height: `${height}px`}}>
          {arrowValue}
        </div>
        <div className="left-size-arrow-item-border"/>
      </div>
    );
  }

  createBottomSizeArrows(sleevesToSort, areaDimension) { // todo consider renaming sleevesToSort to something appropriate
    /**
     * sort and delete elements with the same width
     */
    const bottomArrowSize = sleevesToSort.sort((a, b) => {
      return a.left > b.left ? 1 : -1;
    }).filter((item, pos, self) => {
      return !pos || Math.round(item.widthOfArrow * 1000) / 1000 !== Math.round(self[pos - 1].widthOfArrow * 1000) / 1000;
    });

    return bottomArrowSize.map((item, index, self) => {
      const
        width = !index
          ? item.widthOfArrow
          : item.widthOfArrow - self[index - 1].widthOfArrow,
        left = !index
          ? Math.round(item.left)
          : Math.round(item.left - self[index - 1].left);
      if (index === self.length - 1) {
        const widthOfLastItem =
          this.props.buildValues[areaDimension] * this.props.sizeOfCell / SIZE_OF_CELL - item.widthOfArrow;
        return (
          <React.Fragment key={item.widthOfArrow + 2}>
            {Plan.createBottomSizeArrow(width, item.widthOfArrow, this.getArrowValue(left))}
            {
              this.props.buildValues[areaDimension] !== (Math.round(item.left))
                ? Plan.createBottomSizeArrow(
                widthOfLastItem,
                item.widthOfArrow + 1,
                this.getArrowValue(this.props.buildValues[areaDimension] - item.left))
                : null
            }
          </React.Fragment>
        )
      }
      return (
        Plan.createBottomSizeArrow(width, item.widthOfArrow, this.getArrowValue(left))
      );
    });
  }

  createBottomOverallSizeArrow(areaDimension) {
    const width = this.props.buildValues[areaDimension]
    const arrowValue = this.getArrowValue(width)
    const widthOnScreen = width * this.props.sizeOfCell / SIZE_OF_CELL

    return Plan.createBottomSizeArrow(widthOnScreen, width, arrowValue)
  }

  static createBottomSizeArrow(width, key, arrowValue) {
    return (
      <div className={`sizeArrow`} key={key}>
        <div className="size-arrow-border"/>
        <div className="size-arrow-line" style={{width: `${width}px`}}>
          {arrowValue}
        </div>
        <div className="size-arrow-border"/>
      </div>
    );
  }

  getArrowValue = value => Math.round(value) > 0 ? Math.round(value) : '';
}

/*** prop types for component recommended pass:
 * height of area (in this context height always one),
 * sizeOfCell,
 * numberOfCellsWidth,
 * numberOfCellsHeight;
 * currentStep
 * to create target grid***/
Plan.propTypes = {
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  currentStep: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  areaName: PropTypes.string.isRequired,
  bottom: PropTypes.string,
  borderColor: PropTypes.string,
  dataInputName: PropTypes.string,
  changeInputValue: PropTypes.func,
  isVerticalArrow: PropTypes.bool,
  sizeOfCell: PropTypes.number,
  numberOfCellsWidth: PropTypes.number,
  numberOfCellsHeight: PropTypes.number,
  paddingRight: PropTypes.string,
  withoutResize: PropTypes.bool,
  areaDimension: PropTypes.string,
  withoutDragging: PropTypes.bool,
  stylesForPlan: PropTypes.object
};

const planTarget = {
  drop(props, monitor) {
    /*** get items parameters ***/
    const item = monitor.getItem();
    const itemType = monitor.getItemType();
    let {x, y} = monitor.getSourceClientOffset();
    if (itemType === ItemTypes.CELL) {
      x += props.sizeOfCell / 2;
      y += props.sizeOfCell / 2;
    }
    const innerArea = document.body.getElementsByClassName(
      "inner-plan-step-2"
    )[0];
    const clientBounding = innerArea.getBoundingClientRect();
    clientBounding.x = clientBounding.left;
    clientBounding.y = clientBounding.top;

    /**calculate additional shift for sleeves based on sleeves background**/

    const additionalShift = props.sizeOfCell * sleeveSize[item.background] / SIZE_OF_CELL,
      dimension = item.currentStep <= 3 ? props.buildValues.length : props.buildValues.width;

    const mCoef = props.sizeOfCell > 75 ? sleeveSize[item.background] / 10 : 3 * sleeveSize[item.background] / 10;

    /*** if is remainder of the division, then round x ***/
    const sleeveKoef =
      window.innerWidth <= 420 && itemType === ItemTypes.CELL ? 20 : 0;
    if (
      (clientBounding.x - x + sleeveKoef + props.sizeOfCell / 4) %
      props.sizeOfCell / 4
    ) {
      if (itemType === ItemTypes.LID) {
        x =
          clientBounding.x -
          Math.round((clientBounding.x - x + sleeveKoef) / (props.sizeOfCell / 4)) *
          props.sizeOfCell / 4;
      } else {
        x =
          clientBounding.x -
          Math.round((clientBounding.x - x + sleeveKoef + additionalShift / mCoef) / (props.sizeOfCell)) *
          props.sizeOfCell;
      }
    }

    /*** if is remainder of the division, then round y***/
    if ((clientBounding.y - y + props.sizeOfCell / 4) % (props.sizeOfCell / 4)) {
      const cellOffset = Math.round(clientBounding.height % props.sizeOfCell);
      if (itemType === ItemTypes.LID) {
        y = clientBounding.y -
          Math.round((clientBounding.y - y + cellOffset) / (props.sizeOfCell / 4)) *
          (props.sizeOfCell / 4) + cellOffset - 2;
      } else {
        y = clientBounding.y -
          Math.round((clientBounding.y - y + cellOffset + additionalShift / mCoef) / (props.sizeOfCell)) *
          props.sizeOfCell + cellOffset - 2;
      }
    }

    /** left, top margin of item**/
    let left = x - clientBounding.x,
      top = y - clientBounding.y;
    if (itemType === ItemTypes.CELL) {
      left -= additionalShift / 2;
      top -= additionalShift / 2;
    }

    /**
     * if items type is cells (sleeve) then add additional shift
     * for position sleeve on insects of vertical and horizontal lines
     * **/

    /*** if items type is LID ***/
    if (top < 0)
      top = 0;
    top = Math.round(top);
    if (
      itemType === ItemTypes.LID &&
      !item.widthoutDragging &&
      !(
        top +
        props.sizeOfCell * (
          props.buildValuesSides[item.currentStep - 2].lids[item.index].height / SIZE_OF_CELL) >=
        clientBounding.height
      ) &&
      top >= 0 &&
      left >= 0 &&
      !(
        left +
        props.sizeOfCell * (
          props.buildValuesSides[item.currentStep - 2].lids[item.index].length / SIZE_OF_CELL)
        >=
        clientBounding.width
      )
    ) {
      props.pushLidToTarget(
        item.currentStep - 2,
        item.index,
        top * 20 / props.sizeOfCell,
        left * 20 / props.sizeOfCell
      );
    }

    /*** if items type is CELL todo: consider renaming to SLEEVE ***/
    if (
      itemType === ItemTypes.CELL &&
      !((top + additionalShift) >= clientBounding.height) &&
      !((left + additionalShift) >= clientBounding.width) &&
      top >= 0 &&
      (Math.round((dimension * props.sizeOfCell / SIZE_OF_CELL - left - additionalShift / 2) * 1000) / 1000) >= Math.round(props.sizeOfCell * 1000) / 1000
      &&
      (Math.round((left + (additionalShift / 2)) * 1000) / 1000) >= (Math.round(props.sizeOfCell * 1000) / 1000)
      &&
      (Math.round(((top + additionalShift / 2) * 1000) / 1000) + 1 >= Math.round(props.sizeOfCell / SIZE_OF_CELL))
    ) {
      props.pushAddSleeveToSide({
        side: item.currentStep - 2,
        background: item.background,
        top: top * 20 / props.sizeOfCell,
        left: left * 20 / props.sizeOfCell + ((dimension % SIZE_OF_CELL) / 2),
        index: item.index
      });
    }
  }
};

const collect = connect => ({
  connectDropTarget: connect.dropTarget()
});

const mapStateToProps = state => {
  return {
    buildValuesSides: state.buildValuesSides,
    buildValues: state.buildValues
  };
};
const mapStateToDispatch = {
  pushLidToTarget,
  pushAddSleeveToSide,
  deleteSleeveToSide
};

export default connect(mapStateToProps, mapStateToDispatch)(
  DropTarget([ItemTypes.LID, ItemTypes.CELL], planTarget, collect)(Plan)
);



// WEBPACK FOOTER //
// ./src/containers/steps/BuildSteps/BuildsComponent/Plan.js